/**
 * Nurse Re-evaluation Note — static options + empty form state.
 * Sections mirror Eval & Orders → Nurse Re-evaluation Visit Note screenshots.
 */

import { emptyNurseNotesCommonHeader } from "./nurseNotesCommonHeaderUtils";
import { emptyWoundAssessmentValues } from "./woundAssessmentContent";

export const REEVAL_REASON_OPTIONS = [
  "Routine (Per Plan of Care)",
  "Change in Condition",
  "Post Hospitalization",
  "Post ER Visit",
];

export const CHANGES_SINCE_LAST_OPTIONS = [
  "New Diagnosis",
  "Medication Changes",
  "Change in Vital Signs",
  "Change in Cognitive Status",
  "Change in Functional Status",
  "New Wound/Change in Wound",
];

export const ASSESSMENT_AREA_OPTIONS = [
  "Vital Signs",
  "Pain (0-10)",
  "Cardiovascular",
  "Respiratory",
  "Neurological",
  "GI/GU",
  "Skin/Wound",
  "Nutrition/Hydration",
  "Functional Status",
  "Cognitive Status",
  "Mental Status",
  "Risk for Falls",
  "Infection Risk",
  "Other",
];

export const CHANGE_OPTIONS = ["-", "Improved", "No Change", "Declined", "New"];

export const GOAL_STATUS_OPTIONS = ["Met", "Partially Met", "Not Met"];

export const YES_NO_OPTIONS = ["Yes", "No"];

/** Plan of Care / Orders — multi-select (screenshot: check all that apply). */
export const PLAN_OF_CARE_STATUS_OPTIONS = [
  "Continue Without Changes",
  "Modify Plan of Care",
  "Decrease Frequency",
  "Increase Frequency",
  "New Physician Orders Requested",
  "Discharge Planning Initiated",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

export const emptyAssessmentRow = (area) => ({
  area,
  lastAssessment: "",
  currentAssessment: "",
  change: "",
});

export const emptyGoalRow = (n) => ({
  id: `goal-${n}`,
  label: `Goal ${n}`,
  status: "",
  evidence: "",
  continueGoal: "",
});

export const emptyAssessmentFindings = () =>
  ASSESSMENT_AREA_OPTIONS.map((area) => emptyAssessmentRow(area));

export const emptyGoals = () => [1, 2, 3].map((n) => emptyGoalRow(n));

/** Full editable Nurse Re-evaluation Note payload (JSON on dedicated row). */
export const emptyRnReevalNotePayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  commonHeader: emptyNurseNotesCommonHeader(),

  patientName: "",
  dateOfBirth: "",
  mrn: "",
  address: "",
  phone: "",
  insurance: "",

  visitDate: "",
  reevalReasons: [],
  changesSinceLast: [],
  assessmentFindings: emptyAssessmentFindings(),
  ...emptyWoundAssessmentValues(),
  goals: emptyGoals(),

  /** § Skilled Nursing Need / Medical Necessity */
  skilledNursingNeed: "",

  /** § Plan of Care / Orders */
  planOfCareStatus: [],
  planOfCareComments: "",

  /** § Discharge Planning */
  dischargeAnticipated: "",
  dischargeExpectedDate: "",
  dischargeNeedsPlan: "",
});
